import gql from 'graphql-tag';

export const PHOTO_FRAGMENT = gql`
  fragment PhotoFragment on Photo {
    id
    url
    width
    height
    assetId
    container
  }
`;
